import React, { FunctionComponent } from 'react';

import { Collapse } from '../../../atoms/Collapse';

import $Content from './AccordionContent.styles';

interface AccordionContentProps {
  isNaked: boolean;
  isOpen: boolean;
  componentThemeName?: string;
  isListTheme?: boolean;
  couldUnmountIfClosed?: boolean;
}

const AccordionContent: FunctionComponent<
  React.PropsWithChildren<AccordionContentProps>
> = ({
  children,
  isNaked,
  isOpen,
  componentThemeName,
  isListTheme = false,
  couldUnmountIfClosed,
}) => {
  return (
    <Collapse isOpen={isOpen} couldUnmountIfClosed={couldUnmountIfClosed}>
      <$Content
        $naked={isNaked}
        $componentThemeName={componentThemeName}
        $isList={isListTheme}
      >
        {children}
      </$Content>
    </Collapse>
  );
};

export default AccordionContent;
